import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large",
    title: _ctx.title,
    loading: _ctx.state.is_loading,
    "confirm-button-text": "Подтвердить",
    onConfirm: _ctx.onConfirm,
    onCancel: _ctx.onCancel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_input, {
        placeholder: "Комментарий",
        value: _ctx.state.comment,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.comment) = $event))
      }, null, 8, ["value"])
    ]),
    _: 1
  }, 8, ["title", "loading", "onConfirm", "onCancel"]))
}